import type { Leave, LeaveItem, LeaveListData } from '@/services/api/leaves'

import { mockLeaves } from '../fixtures/leaves'
import { delay, nowISO } from '../helpers'

let leaves: Leave[] = [...mockLeaves]

export const leavesApiMock = {
  create: async (
    params: { employeeID: string; storeID: string },
    payload: LeaveItem[],
  ): Promise<void> => {
    const created: Leave[] = payload.map((item) => ({
      ...item,
      employeeID: params.employeeID,
      storeID: params.storeID,
      createdAt: nowISO(),
      updatedAt: nowISO(),
    }))
    leaves = [...leaves, ...created]
    return delay(undefined)
  },

  delete: async (
    params: { employeeID: string; storeID: string },
    payload: LeaveItem[],
  ): Promise<void> => {
    const toRemove = new Set(payload.map((item) => `${item.startAt}_${item.endAt}`))
    leaves = leaves.filter(
      (leave) =>
        !(
          leave.employeeID === params.employeeID &&
          leave.storeID === params.storeID &&
          toRemove.has(`${leave.startAt}_${leave.endAt}`)
        ),
    )
    return delay(undefined)
  },

  getByRange: async (params: {
    employeeID: string
    storeID: string
    leaveStart: string
    leaveEnd: string
  }): Promise<Leave> => {
    const match = leaves.find(
      (leave) =>
        leave.employeeID === params.employeeID &&
        leave.storeID === params.storeID &&
        leave.startAt <= params.leaveEnd &&
        leave.endAt >= params.leaveStart,
    )
    return delay(
      match ?? {
        employeeID: params.employeeID,
        storeID: params.storeID,
        startAt: params.leaveStart,
        endAt: params.leaveEnd,
        createdAt: nowISO(),
        updatedAt: nowISO(),
      },
    )
  },

  list: async (storeID: string): Promise<LeaveListData> => {
    const storeLeaves = leaves
      .filter((leave) => leave.storeID === storeID)
      .map(({ employeeID, startAt, endAt }) => ({ employeeID, startAt, endAt }))
    return delay({ leaves: storeLeaves })
  },
}
